module.exports = __webpack_public_path__ + "components/flag/static/square/is-12991eb31b42bfe3e737912059e48426.svg";